const mvSwiper = new Swiper('.mv-swiper', {
    // Optional parameters
    loop: true,
    effect: 'slide',
    slidesPerView: 1.5,
    spaceBetween: '10px',
    centeredSlides: true,
    autoplay: {
        delay: 3000,
    },
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
breakpoints: {
    768: {
        slidesPerView: 1.5,
        spaceBetween: 10,
        centeredSlides: true,
        pagination: false,  // PCではドットを非表示
    },
    0: {
        slidesPerView: 1.15,
        spaceBetween: 8,
        centeredSlides: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        }  // スマホでドットを表示
    }
}
  });